<template>
    <div>
        <!-- <hr v-if="depth !=0" style="margin: 3px 0">     -->
        <div class="node-hover border-t">
            <div
                :style="{'margin-left':30 * depth + 'px'}"
            >
                <div class="d-flex justify-content-between">
                    <div  class="node" @click="expanded = !expanded">
                        <span v-if="hasChildren" class="mr-5">{{ expanded ? '&#9660' : '&#9658'}}</span>
                        <span v-if="node.type === 'group'">{{ displayName }}</span>
                    </div>
                    <strong v-if="!expanded && node.type === 'group'">{{ commaFormat(node.total, noOfDecimals) }}</strong>
                </div>
                <div
                    class="d-flex cursor-initial justify-content-between"
                    v-if="node.type === 'endpoint'"
                >
                    <span class="mb-0">{{ displayName }}</span>
                    <span class="mb-0" role="button" @click="goToGeneralLedger(node.id)">
                        {{ commaFormat(node.total, noOfDecimals) }}
                    </span>
                </div>
            </div>
        </div>
        <template v-if="expanded">
            <TreeBrowser
                v-if="hasChildren"
                v-for="item in node.child"
                :key="item.name"
                :parent="node"
                :depth="depth + 1"
                :node="item"
                ref="childrenTree"
            />
            <div v-if="node.type === 'group'">
                <!-- <hr style="margin: 3px 0"> -->
                <div class="node-hover border-t border-b">
                    <div class="d-flex justify-content-between">
                        <strong
                            :style="{'margin-left':30 * depth + 'px'}"
                        >
                            Total {{ node.name}}
                        </strong>
                        <strong>{{ commaFormat(node.total, noOfDecimals) }}</strong>
                    </div>
                    <!-- <hr style="margin: 3px 0"> -->
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import {useRoute, useRouter} from "vue-router";
import figureFormatter from '@/services/utils/figureFormatter'
import handleRedirectToPage from "@/services/modules/redirectToPage";

export default {
    name: 'TreeBrowser',
    data () {
        return {
            expanded: this.$route.query.expand_all ? !!parseInt(this.$route.query.expand_all) : false,
            expandAll: false,
        }
    },
    computed: {
        hasChildren () {
            return this.node && this.node.child && this.node.child.length
        },
        type () {
            return this.node && this.node.type
        },
        noOfDecimals() {
            return this.$route.query.decimals ?? 2
        },
        showAccountCode() {
            if (this.$route.query.show_account_code === undefined) return false
            return !!parseInt(this.$route.query.show_account_code)
        },
        displayName() {
            if (!this.showAccountCode) return this.node.name
            if (!this.node.account_code) return this.node.name
            return `${this.node.account_code} - ${this.node.name}`
        },
    },
    props: {
        node: {
            default: {}
        },
        depth: {
            type: Number,
            default: 1
        },
        parent: {
            default: []
        }
    },
    methods: {
        expandTree(expandAll = true) {
            this.expanded = expandAll

            // Wait for DOM and refs to be updated
            this.$nextTick(() => {
                const children = this.$refs.childrenTree;

                if (Array.isArray(children) && children.length) {
                    children.forEach(child => child.expandTree());
                }
            });
        }
    },
  setup() {
    const {commaFormat} = figureFormatter()
    const {goToPage} = handleRedirectToPage()
    const route  = useRoute();
    const router = useRouter();

    const goToGeneralLedger = (headId) => {
      let param = {
        companyId: route.params.companyId,
        moduleId: route.params.moduleId,
        menuId: route.params.menuId,
        pageId: route.params.pageId
      }

      let query = route.query;
      query.headId = headId;

      let paramsData = {
        name: 'general-ledger',
        params: param,
        query: query
      };

      const routeData = router.resolve(paramsData)

      window.open(routeData.href, '_blank');
    }

    return {
      commaFormat,
      goToPage,
      goToGeneralLedger
    }
  },
}
</script>

<style scoped>
span {
    font-size:1.2em;
}
</style>
